import { effect, Injectable, signal } from '@angular/core';
import { isMobile as detectMobile } from 'is-mobile';

@Injectable({
  providedIn: 'root'
})
export class MobileDetectorService {
  readonly isMobile = signal<boolean>(detectMobile());

  private readonly isMobileEffect = effect(() => {
    if (this.isMobile()) {
      document.body.classList.add('mobile');
    }
  })
}
